import { AnchorProps, Text } from "@mantine/core"
import { LinkAnchor } from "../../../../../-components/link-anchor"
import { SimplePerson } from "../../../../../../../@client/Theasoft_ApiServer_Persons"
import { PermissionType_AllValues } from "../../../../../../../@client/Theasoft_Data_Permissions"
import { useBatchedPersonContactDataPermissions } from "../../../../../../../-dataloaders/conact-data-permissions"
import { useBatchedSimplePerson } from "@/-dataloaders/simple-persons"

interface PersonLinkProps extends AnchorProps {
  personId: number
}

// TODO: move to components
export function PersonLink({ personId, ...props }: PersonLinkProps) {
  const {
    data: { 0: contactDataPermission },
  } = useBatchedPersonContactDataPermissions(personId)
  const { data: person } = useBatchedSimplePerson(personId)

  return contactDataPermission !== PermissionType_AllValues[0] ? (
    <LinkAnchor
      c={"var(--mantine-color-text)"}
      underline="hover"
      to="/app/contacts/$id"
      params={{ id: personId.toString() }}
      search={{ tab: "start" }}
      {...props}
    >
      {person?.name}
    </LinkAnchor>
  ) : (
    <Text c={"var(--mantine-color-text)"} {...props}>
      {person?.name}
    </Text>
  )
}

interface PersonLinksProps extends AnchorProps {
  persons: SimplePerson[]
}

export function PersonLinks({ persons, ...props }: PersonLinksProps) {
  return persons.map((v, i) => (
    <React.Fragment key={v.personId}>
      <PersonLink personId={v.personId} {...props} />

      {i < persons.length - 1 ? ", " : ""}
    </React.Fragment>
  ))
}
